module.exports = __webpack_public_path__ + "img/box6-24.973a4550.png";